/**
 * 897(수급업체 안전보건수준평가) 글 중복 제거
 *
 * 845 안전작업허가서에서 897 글을 생성할 때 저장 버튼 중복 클릭으로 같은 parentsPostId 를 가진
 * 글이 여러 건 생성된 이력이 있어, 조회 시 parentsPostId 기준으로 1건만 남긴다.
 *
 * 남기는 기준:
 *   1) 현장평가(evaluationList[1]) 점수가 입력된 글 우선
 *   2) 그 외에는 id 가 가장 큰(가장 최근) 글
 * parentsPostId 가 없는 글(897에서 직접 작성)은 제거 대상이 아니다.
 *
 * @param {Array} list
 * @param {{ getContent: (item) => object, getId: (item) => number }} accessors
 *   getContent: post_content 를 파싱한 객체({ parentsPostId, body: { evaluationList } }) 반환
 *   getId: 글 id 반환
 */
export function dedupeByParentsPostId(list, { getContent, getId }) {
  if (!Array.isArray(list) || list.length === 0) return list;

  const hasSiteScore = (content) => {
    const row = content && content.body && content.body.evaluationList && content.body.evaluationList[1];
    return !!(row && Array.isArray(row.childs) && row.childs.some((child) => Number(child.value) > 0));
  };

  const keep = new Map(); // parentsPostId -> item
  const result = [];

  for (const item of list) {
    const content = getContent(item) || {};
    const parentsPostId = content.parentsPostId;
    if (!parentsPostId) {
      result.push(item);
      continue;
    }

    const key = `${parentsPostId}`;
    const prev = keep.get(key);
    if (!prev) {
      keep.set(key, item);
      continue;
    }

    const prevSite = hasSiteScore(getContent(prev));
    const currSite = hasSiteScore(content);
    const currIsNewer = Number(getId(item)) > Number(getId(prev));
    if ((currSite && !prevSite) || (currSite === prevSite && currIsNewer)) {
      keep.set(key, item);
    }
  }

  // 원래 순서를 유지하면서 살아남은 글만 반환
  const survivors = new Set(keep.values());
  return list.filter((item) => {
    const content = getContent(item) || {};
    return !content.parentsPostId || survivors.has(item);
  });
}
